import React from "react";
import { useCreatePerDiemExpenseRateMutation } from "./queries.generated";
import { MutationForm } from "~/components/forms/MutationForm";
import { CreateExpenseRateFormData, CreateExpenseRateFormProps } from "./types";
import { parseNum } from ".";
import { PerDiemKind, ValidationResponse } from "~/gql/types";

export const NewPerDiemExpenseRate: React.FC<CreateExpenseRateFormProps> = (
  props
) => {
  const { setLoading, onSuccess, initialValues, rateSheetName, children } =
    props;

  const [rawPerDiemMutation] = useCreatePerDiemExpenseRateMutation();

  const handleSubmit = async (values: CreateExpenseRateFormData) => {
    const variables = {
      name: values?.name!,
      invoiceLabel: values?.invoiceLabel || null,
      expenseAccount: values?.expenseAccount || null,
      glAccount: values?.glAccount || null,
      rateSheetName: rateSheetName,
      billableOverride: parseNum(values?.billableOverride),
      kind: values?.kind as PerDiemKind,
      quantity: parseNum(values?.quantity)!,
    };

    const result = await rawPerDiemMutation({ variables });

    return result?.data?.expenseRates?.addPerDiemRate as ValidationResponse;
  };

  return (
    <MutationForm
      setLoading={setLoading}
      initialValues={initialValues}
      runMutation={handleSubmit}
      onSuccess={onSuccess}
      allowPristineSubmit
    >
      {children}
    </MutationForm>
  );
};
